export function getChildHeightGrow(childHeightGrow, childId) {
    const value = childHeightGrow?.[childId];
    return typeof value === 'number' && value > 0 ? value : 0;
}

export function getContainerGridTemplateRows(childrenIds = [], childHeightGrow) {
    if (!childrenIds.length) {
        return undefined;
    }

    const hasGrowRow = childrenIds.some((childId) => getChildHeightGrow(childHeightGrow, childId) > 0);
    if (!hasGrowRow) {
        return undefined;
    }

    return childrenIds
        .map((childId) => {
            const grow = getChildHeightGrow(childHeightGrow, childId);
            return grow > 0 ? `minmax(0, ${grow}fr)` : 'auto';
        })
        .join(' ');
}
